var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLiveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 36,
    viewBox: "0 0 76 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B80000",
    d: "M0 0h76v36H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.211 27V10.248h3.648V23.76h6.384V27H10.211zm14.079 0v-2.904h2.16V13.152h-2.16v-2.904h7.968v2.904h-2.16v10.944h2.16V27H24.29zm16.895 0l-5.4-16.752h3.696l2.496 8.04 1.32 5.256h.072l1.272-5.256 2.496-8.04h3.576L45.265 27h-4.08zm13.722 0V10.248h11.4v3.24h-7.752v3.432h6.648v3.216h-6.648v3.624h7.752V27h-11.4z",
    fill: "#E9E9E9"
  })));
}

export default __webpack_public_path__ + "b100b6c25b609a0f64f68b5b81fdad8e.svg";
export { SvgLiveIcon as ReactComponent };